import { render, staticRenderFns } from "./Destacados.vue?vue&type=template&id=95640086"
import script from "./Destacados.vue?vue&type=script&lang=js"
export * from "./Destacados.vue?vue&type=script&lang=js"
import style0 from "./Destacados.vue?vue&type=style&index=0&id=95640086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports